/*
 * @Author: Lim 
 * @Date: 2020-09-04 13:33:18 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-11 11:04:01
 */

import React, {  } from 'react';
import style from "./Atag.module.scss"
import cn from "classnames";
import { initConfig, unitFilter } from '../common';

export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        text: '未知内容',
        type: '1',
        underline: false,
        href: '',
        hover: false,
        fontSize :12,
        check(){}
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     */
    const { 
        text,
        type, 
        underline, 
        href, 
        hover, 
        fontSize,
        check
    } = initConfig( defaultConfig, props.config );
    
    const defaultFontSize = unitFilter ( fontSize );
    /**
     * Func
     * 点击后回调
     */
    const _check = () => {
        check();
        if( href !== "" ) window.location.href = href;
    }
    
    return (
        <div 
            className = {cn(
            style.alink,
            type == '1' ? style.blue : style.red,
            underline === true ? style.underline : "",
            )}
            onClick = { ()=> _check() }
        >
            <span style={{ fontSize: defaultFontSize }}>{ text }</span>
            {
                hover === false ? "" :
                <div>
                    { props.children }
                </div>
            }
        </div>
    )
}